import { v4 as uuid } from "uuid";
import mapKnownValues from "../../utils/mapKnownValues";

export type PlanAPIResponse = {
  planInvestmentMenuFileNames: string[];
  planDocumentFileNames: string[];
  planId: number;
  planName: string;
  planNumber: string;
  planType: string;
  recordKeeper: string;
  tenantId: number;
};

export class Plan {
  planInvestmentMenuFileNames: string[] = [];
  planDocumentFileNames: string[] = [];
  planId = -1;
  planName = "";
  planNumber = "";
  planType = "";
  recordKeeper = "";
  tenantId = -1;

  uid = uuid();
  _originalData = "";
  _planFilesToBeUploaded: File[] = [];
  _planInvestmentFilesToBeUploaded: File[] = [];

  constructor(params: Partial<Plan> = {}) {
    mapKnownValues(this, params);
    if (params?.uid !== undefined) {
      this.uid = params.uid;
    } else if (params?.planId && params.planId !== -1) this.uid = params.planId;
    if (!params?._originalData) {
      this._originalData = JSON.stringify({
        ...this,
        uid: undefined,
        _originalData: undefined,
      });
    }
  }

  static fromAPI(response: PlanAPIResponse) {
    return new Plan({
      ...response,
    });
  }

  get isCompleted() {
    return this.planName && this.recordKeeper;
  }

  get hasChanged() {
    return (
      JSON.stringify({
        ...this,
        _originalData: undefined,
        uid: undefined,
      }) !== this._originalData
    );
  }

  toJSONForAPI() {
    return JSON.stringify({
      ...this,
      uid: undefined,
      _originalData: undefined,
      _planFilesToBeUploaded: undefined,
      _planInvestmentFilesToBeUploaded: undefined,
    });
  }
}
